import React, { useEffect, useState } from "react";
import GrayCard from "components/gray-card";
import Typography from "components/typography";
import { Colors } from "utils/colors";
import styled from "styled-components";
import Radio from "components/radio";
import DateInput from "components/inputs/date-input";

interface IProps {
  releaseDate?: Date | null;
  setReleaseDate: (date: Date | null) => void;
}
const OriginalReleaseDate = ({ releaseDate, setReleaseDate }: IProps) => {
  const [releasedBefore, setReleasedBefore] = useState(false);
  const [date, setDate] = useState<Date | null>(releaseDate || new Date());

  useEffect(() => {
    setReleaseDate(date);
  }, [date]);

  return (
    <GrayCard title="Original Release Date">
      <Typography weight="medium" color={Colors.grey400} mb="1.6">
        Has this release been released before?
      </Typography>
      <RadioItems>
        <RadioItem>
          <Radio
            value={releasedBefore}
            onClick={() => setReleasedBefore(true)}
          />
          <Typography color={Colors.white200} ml="0.4">
            Yes
          </Typography>
        </RadioItem>
        <RadioItem>
          <Radio
            value={!releasedBefore}
            onClick={() => setReleasedBefore(false)}
          />
          <Typography color={Colors.white200} ml="0.4">
            No
          </Typography>
        </RadioItem>
      </RadioItems>
      {releasedBefore && (
        <DateInputItem>
          <DateInput
            label="Select original release date"
            initialDate={date}
            maxDate={new Date()}
            selectDate={(date) => setDate(date)}
          />
        </DateInputItem>
      )}
    </GrayCard>
  );
};

export default OriginalReleaseDate;

const RadioItems = styled.div`
  display: flex;
  align-items: center;
`;

const RadioItem = styled.div`
  display: flex;
  align-items: center;
  margin-right: 5rem;
`;

const DateInputItem = styled.div`
  margin-top: 2.4rem;
  width: 24rem;
`;
